import { createFigsFontFaces } from '@syconium/little-miss-figgy/dist/themes/provider/figs-font'

export const figsFont = createFigsFontFaces()
